import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cardHover: {
    // padding: theme.spacing(5),
    position: 'absolute', top: 0,
    background: 'linear-gradient(152deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 60%)',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10%'
  }
}));

const ActionsCard = ({action}) => {
  const classes = useStyles();
  const [isShown, setIsShown] = useState(false);

  return (
    <>
      <Card>
        <CardActionArea
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
        >
          <CardMedia
            alt={action.alt}
            component="img"
            image={action.img}
            object-fit
            title={action.title}
          />
          <Fade in={!isShown}>
            <Paper
              className={classes.cardHover}
            >
              <Typography
                align="center"
                component="h3"
                style={{color: 'white', margin: 0}}
                variant="h3"
              >
                {action.desc}
              </Typography>
            </Paper>

          </Fade>
        </CardActionArea>
      </Card>
    </>
  );
}

ActionsCard.propTypes = {
  action: PropTypes.object,
};

export default ActionsCard;
